import { createFeature, createReducer, on } from '@ngrx/store';
import { AuthenticatedUser } from '../models/authenticated-user.model';
import {
  AuthApiActions,
  AuthDeviceActions,
  AuthLoginActions,
  AuthProfileActions,
  AuthShellActions,
  AuthTwoFactorLoginActions,
  PasswordResetActions,
} from './auth.actions';

export const authFeatureKey = 'auth';

export enum AuthStatus {
  Pending = 'pending',
  Initialized = 'initialized',
}

export interface State {
  user: AuthenticatedUser | null;
  status: AuthStatus;
  loading: boolean;
  error: unknown;
}

export const initialState: State = {
  user: null,
  status: AuthStatus.Pending,
  loading: false,
  error: null,
};

export const authReducer = createReducer(
  initialState,
  on(
    AuthApiActions.loginSuccess,
    AuthDeviceActions.refreshed,
    AuthApiActions.updateProfileSuccess,
    (state, { user }) => ({
      ...state,
      user,
      loading: false,
    }),
  ),
  on(
    AuthApiActions.resetSuccess,
    AuthApiActions.forgotPwdSuccess,
    (state, data) => ({
      ...state,
      data,
      loading: false,
    }),
  ),
  on(AuthApiActions.twoFactorAwaiting, (state) => ({
    ...state,
    loading: false,
  })),
  on(AuthApiActions.twoFactorRequired, (state) => ({
    ...state,
    loading: false,
  })),
  on(AuthTwoFactorLoginActions.login, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AuthApiActions.loginFailure,
    AuthApiActions.resetFailure,
    AuthApiActions.forgotPwdFailure,
    AuthApiActions.updateProfileFailure,
    (state, { error }) => ({
      ...state,
      error,
      loading: false,
    }),
  ),
  on(AuthDeviceActions.initialized, (state, { user }) => ({
    ...state,
    user,
    status: AuthStatus.Initialized,
  })),
  on(
    AuthLoginActions.login,
    PasswordResetActions.reset,
    AuthLoginActions.forgotPwd,
    (state) => ({
      ...state,
      loading: true,
    }),
  ),
  on(
    AuthDeviceActions.logout,
    AuthShellActions.logout,
    AuthDeviceActions.expired,
    (state) => ({
      ...state,
      user: null,
    }),
  ),
  on(AuthProfileActions.update, (state) => ({
    ...state,
    loading: true,
  })),
);

export const authFeature = createFeature({
  name: authFeatureKey,
  reducer: authReducer,
});
